import React, { useState } from 'react';
import { LedgerEntry, typeColors } from '../accountingTypes';
import styles from './LedgerTable.module.css';

interface LedgerTableProps {
  items: LedgerEntry[];
  onExport: () => void;
  exporting?: boolean;
}

const TABS = ['Customer', 'Date Range', 'Type'] as const;

export const LedgerTable: React.FC<LedgerTableProps> = ({ items, onExport, exporting }) => {
  const [activeTab, setActiveTab] = useState<string>('Customer');

  return (
    <div className={styles.wrapper}>
      {/* Tab Bar */}
      <div className={styles.tabBar}>
        <div className={styles.tabs}>
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <button
          type="button"
          className={styles.exportBtn}
          onClick={onExport}
          disabled={exporting}
          title="Download this ledger view as CSV, generated server-side from the current filters"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
          </svg>
          {exporting ? 'Exporting…' : 'Export'}
        </button>
      </div>

      {/* Table */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>DATE</th>
              <th>CUSTOMER</th>
              <th>TYPE</th>
              <th>REFERENCE</th>
              <th>DESCRIPTION</th>
              <th className={styles.right}>DEBIT</th>
              <th className={styles.right}>CREDIT</th>
              <th className={styles.right}>BALANCE</th>
            </tr>
          </thead>
          <tbody>
            {items.map((entry, idx) => {
              const tc = typeColors[entry.type];
              return (
                <tr key={idx}>
                  <td className={styles.date}>{entry.date}</td>
                  <td className={styles.customer}>{entry.customer}</td>
                  <td>
                    <span className={styles.typeBadge}>
                      <span className={styles.typeDot} style={{ background: tc.dot }} />
                      <span style={{ color: tc.label }}>{entry.type}</span>
                    </span>
                  </td>
                  <td className={styles.reference}>{entry.reference}</td>
                  <td className={styles.description}>{entry.description}</td>
                  <td className={`${styles.right} ${entry.debit !== '—' ? styles.debitValue : styles.dash}`}>
                    {entry.debit}
                  </td>
                  <td className={`${styles.right} ${entry.credit !== '—' ? styles.creditValue : styles.dash}`}>
                    {entry.credit}
                  </td>
                  <td className={`${styles.right} ${styles.balance}`}>{entry.balance}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
